import angular from 'angular'

const dropdownModule = angular
    .module('app.common.dropdown', [])

export default dropdownModule.name

/**
 * config: {
 * handler(){}
 * hasPermit: ''//权限码
 * }
 */
dropdownModule.directive('btnDropdown', ['operationService', (operationService) => ({
    restrict: 'AE',
    replace: true,
    scope: {
        config: '<',
        btnClass: '@',
    },
    template: `
            <div class="u-plbtngroup hoverColor" ng-init="isCollapsed=false" ng-click="isCollapsed=!isCollapsed" ng-mouseleave="isCollapsed=false">
                <span class="plbtngrouptxt" ng-class="btnClass">{{config.btnText}}</span>
                <i class="pl-arrow icon iconfont {{btnClass}}" style="border-left: none" ng-class="{true: 'icon-arrow-up',false: 'icon-arrow-down'}[isCollapsed]"></i>
                <ul class="drop-menu" ng-show="isCollapsed">
                    <li ng-repeat="option in config.options">
                        <a class="btn pl-btns" ng-click="option.handler()" ng-show="option.hasPermit && !option.isHide">{{option.text}}</a>
                    </li>
                </ul>
            </div>
        `,
    link(scope) {
        scope.$watch('config.options', () => {
            scope.config.options.forEach((option) => {
                option.hasPermit = option.hasPermit ? operationService.hasPermit(option.hasPermit) : true
            })
        })
    },
})])


// WEBPACK FOOTER //
// ./src/components/btnDropdown/index.js